<template>
	<div class="rs-user-menu user-wrapper">
		<div v-if="isWorkbench" class="waitCheck">
			<a-icon type="mail" class="mailIcon" />
			<div class="waitCheckCount" v-if="waitCheckCount > 0">
				{{ waitCheckCount > 99 ? '99+' : waitCheckCount }}
			</div>
		</div>
		<router-link to="/Settings/UserCenter">
			<img src="~@/assets/images/user.png" alt="" />{{
				$store.state.user.userInfo && $store.state.user.userInfo.userName
			}}</router-link
		>
		<a-divider type="vertical" />
		<a href="javascript:" @click="showChangeLog">版本信息</a>
		<a-divider type="vertical" />
		<router-link to="/Settings/Password">修改密码</router-link>
		<a-divider type="vertical" />
		<a href="javascript:" @click="handleLogout">退出</a>
		<a-modal title="版本信息" v-model="changeLogVisible" :footer="null">
			<div class="change-log-modal">
				<h3>人伤探视新版本1.25.0</h3>
				<!-- <h4>新增</h4> -->
				<div>
					<span class="order-num">1、</span>增加全流程任务未决跟踪管理；
				</div>
				<div><span class="order-num">2、</span>增加未决回访问卷管理；</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import watermark from '@/utils/watermark'
export default {
	name: 'UserMenu',
	components: {},
	data() {
		return {
			changeLogVisible: false,
			isWorkbench: false,
			timer: null,
		}
	},
	computed: {
		...mapState({
			waitCheckCount: state => state.user.waitCheckCount,
		}),
	},
	watch: {
		$store: {
			handler(val) {
				if (val.state.user.userInfo) {
					this.drawWatermark()
				} else {
					this.removeWatermark()
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.isWorkbench = this.$store.state.user.roles.menuPermissions.includes(
			'workbenchCheckList'
		)
		if (this.isWorkbench) {
			this.$store.dispatch('user/getCountInfo')
			this.timer = setInterval(() => {
				this.$store.dispatch('user/getCountInfo')
			}, 1000 * 60)
		}
		this.$ls.remove('firstLogin1.17.0')
		if (!this.$ls.get('firstLogin1.25.0')) {
			this.showChangeLog()
			this.$ls.set('firstLogin1.25.0', 1)
		}
	},
	destroyed() {
		this.timer = null
	},
	methods: {
		...mapActions('user', ['Logout']),
		showChangeLog() {
			this.changeLogVisible = true
		},
		handleLogout() {
			const that = this

			this.$confirm({
				title: '提示',
				content: '您确定要退出么？',
				onOk() {
					return that
						.Logout()
						.then(() => {
							window.location.replace(`${location.origin}/passport/login`)
						})
						.catch(err => {
							that.$message.error(err.message)
						})
				},
				onCancel() {},
			})
		},
		drawWatermark() {
			const userInfo = this.$store.state.user.userInfo
			const mobile = userInfo.mobile ? userInfo.mobile.substr(-4) : ''
			if (userInfo) {
				watermark.init({
					watermark_txt: `${userInfo.name}${mobile}`,
					watermark_width: 200,
					watermark_x: 0,
					watermark_y: 0,
					watermark_x_space: 50,
					watermark_y_space: 50,
					watermark_alpha: 0.05,
					watermark_fontsize: '30px',
					watermark_angle: 35,
				})
			}
		},
		removeWatermark() {
			try {
				watermark.remove()
			} catch (err) {
				// 忽略报错
			}
		},
	},
}
</script>

<style lang="less" scoped>
.change-log-modal {
	h3,
	h4 {
		line-height: normal;
		font-weight: bold;
		margin-left: 28px;
	}
	h4 {
		margin-top: 5px;
		margin-bottom: 5px;
	}
	padding: 8px;
	line-height: 2;
	> div {
		display: flex;
	}
	.order-num {
		flex-shrink: 0;
		width: 20px;
		margin-right: 8px;
		text-align: right;
		display: inline-block;
		white-space: nowrap;
	}
}
.rs-user-menu {
	margin-right: 4px;
	color: #fff;
	display: flex;
	align-items: center;
	.waitCheck {
		display: flex;
		align-items: center;
		position: relative;
		margin-right: 20px;
		.mailIcon {
			font-size: 20px;
		}
		.waitCheckCount {
			border-radius: 50%;
			background: red;
			position: absolute;
			bottom: 12px;
			right: -15px;
			color: #fff;
			padding: 4px 6px;
			font-size: 12px;
			text-align: center;
			line-height: 1;
		}
	}

	img {
		margin-right: 6px;
	}
	/deep/ .ant-divider {
		margin: 0 16px;
	}
	a {
		&:first-of-type {
			display: flex;
			align-items: center;
		}
		color: #fff;
		&:hover {
			color: #fff;
		}
	}
}
</style>
